"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactMetadata01 = function ReactMetadata01(_ref) {
  var canonical = _ref.canonical,
      defaultLang = _ref.defaultLang,
      description = _ref.description,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? true : _ref$index,
      image = _ref.image,
      keywords = _ref.keywords,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      lat = _ref.lat,
      links = _ref.links,
      lng = _ref.lng,
      title = _ref.title,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "website" : _ref$type,
      url = _ref.url;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    htmlAttributes: {
      lang: lang
    }
  }, title && /*#__PURE__*/_react.default.createElement("title", null, title), description && /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: description
  }), keywords && /*#__PURE__*/_react.default.createElement("meta", {
    name: "keywords",
    content: keywords
  }), lat && lng && /*#__PURE__*/_react.default.createElement("meta", {
    name: "ICBM",
    content: lat + ", " + lng
  }), lat && lng && /*#__PURE__*/_react.default.createElement("meta", {
    name: "geo.position",
    content: lat + ", " + lng
  }), index ? /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: "index, follow"
  }) : /*#__PURE__*/_react.default.createElement("meta", {
    name: "robots",
    content: "noindex, nofollow"
  }), links && Object.entries(links).map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("link", {
      key: index,
      rel: "alternate",
      hreflang: item[0],
      href: item[1]
    });
  }), defaultLang && links && /*#__PURE__*/_react.default.createElement("link", {
    rel: "alternate",
    hreflang: "x-default",
    href: links[defaultLang]
  }), canonical && /*#__PURE__*/_react.default.createElement("link", {
    rel: "canonical",
    href: canonical
  }), image && /*#__PURE__*/_react.default.createElement("meta", {
    name: "image",
    content: image
  }), url && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:url",
    content: url
  }), title && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:title",
    content: title
  }), description && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:description",
    content: description
  }), type && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:type",
    content: type
  }), image && /*#__PURE__*/_react.default.createElement("meta", {
    property: "og:image",
    content: image
  })));
};

ReactMetadata01.propTypes = {
  canonical: _propTypes.default.string,
  description: _propTypes.default.string,
  index: _propTypes.default.bool,
  image: _propTypes.default.string,
  keywords: _propTypes.default.string,
  lang: _propTypes.default.string,
  lat: _propTypes.default.string,
  links: _propTypes.default.object,
  lng: _propTypes.default.string,
  title: _propTypes.default.string,
  url: _propTypes.default.string
};
var _default = ReactMetadata01;
exports.default = _default;